@if (promptOpen()) {
  <div class="cookie-consent-banner fixed bottom-0 inset-x-0 z-50 bg-surface border-t border-border">
    <div class="max-w-7xl mx-auto px-6 py-4 flex flex-col md:flex-row items-center gap-4">
      <p class="text-sm text-text-muted flex-grow">
        We use cookies for analytics to help us understand how our Site is used. See our
        <a routerLink="/cookie-policy" class="text-primary underline hover:opacity-85">Cookie Policy</a>
        for details.
      </p>
      <div class="flex gap-3 shrink-0">
        <button
          type="button"
          (click)="reject()"
          class="px-4 py-2 text-sm rounded-md border border-border text-text-main hover:bg-background transition-colors">
          Reject
        </button>
        <button
          type="button"
          (click)="accept()"
          class="px-4 py-2 text-sm rounded-md bg-primary text-white hover:opacity-90 transition-opacity">
          Accept
        </button>
      </div>
    </div>
  </div>
}
